import { array, boolean, mixed, number, object, string } from "yup"
import addressModel from "./atoms/address.model"

export const currentStockPercentageField = number()
  .min(0)
  .max(100)
  .label("Current Stock Percentage")
  .transform(v => (v || v === 0 ? v : null))
  .nullable()
export const DCRegistrationFormModel = object({
  basicDetails: object({
    id: string(),
    archive: boolean(),
    name: string().min(3).required("Please enter a valid name"),
    codename: string(),
    photos: array().of(mixed()),
    address: addressModel.required("Please enter the address!"),
    isManufacturingPlant: string(),
    assignedCpc: mixed(),
    colorCode: mixed(),
    geometry: mixed(),
    groupVisibility: array().of(mixed()),
    primaryPoc: mixed(),
    companyCode: string(),
    salesOfcCode: string(),
    partnerCode: string(),
    plantCode: string()
      .min(1)
      .required("Please enter a valid plant code")
      .label("Plant Code"),
    storeCode: string()
      .min(1)
      .required("Please enter a valid store code")
      .label("Store Code"),
    customerCode: string()
      .min(1)
      .required("Please enter a valid customer code")
      .label("Customer Code"),
    pointOfContacts: array().of(mixed()),
    allowedDepartments: array().of(mixed()),
  }),
  areasServed: array().of(mixed()),
  surveyAreas: array().of(mixed()),
  billingDetails: object({
    applicable: string(),
    gstin: string()
      .when("applicable", {
        is: "yes",
        then: string()
          .matches(
            /\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/,
            "Please enter a valid GSTIN"
          )
          .required(),
      })
      .label("GSTIN")
      .transform(v => v || ""),
    businessPlace: string()
      .when("applicable", {
        is: "yes",
        then: string().required(),
      })
      .transform(v => v || "")
      .label("Business Place"),
    profitCenter: string().transform(v => v || ""),
    costCenter: string().transform(v => v || ""),
    registeredName: string()
      .when("applicable", {
        is: "yes",
        then: string()
          .required("Please enter a valid registered entity name")
          .matches(
            /^[aA-zZ\s]+$/,
            "Only alphabets are allowed for registered entity name "
          ),
      })
      .transform(v => v || "")
      .label("Registered Name"),
    address1: string()
      .when("applicable", {
        is: "yes",
        then: string().required(),
      })
      .transform(v => v || "")
      .label("Address Line 1"),
    address2: string()
      .when("applicable", {
        is: "yes",
        then: string().required(),
      })
      .transform(v => v || "")
      .label("Address Line 2"),
    state: mixed()
      .when("applicable", {
        is: "yes",
        then: string().required(),
      })
      .transform(v => v || ""),
    district: string()
      .when("applicable", {
        is: "yes",
        then: string().required(),
      })
      .transform(v => v || ""),
    pincode: string()
      .when("applicable", {
        is: "yes",
        then: string().required().length(6, "Pincode should only be 6 digits"),
      })
      .transform(v => v || ""),
  }),
  licenseDetails: array().of(
    object().shape({
      id: mixed(),
      certificationType: mixed().required("Please select Licence Type"),
      idNumber: string().required().label("Licence Number"),
      validFrom: string().required().label("Valid From"),
      validTill: string().nullable().label("Valid Till"),
      attachments: array()
        .of(mixed())
        .required()
        .label("Attachments")
        .min(1, "Please add atleast one attachment for the licence"),
    })
  ),
  paymentMethods: array().of(
    object().shape({
      id: string().notRequired(),
      accountNumber: string().required().label("Account Number"),
      accountHolderName: string().when("paymentMethod", (value, schema) => {
        if (value.id === "BANK") {
          return string()
            .required()
            .min(3)
            .matches(
              /^[aA-zZ\s]+$/,
              "Only alphabets are allowed for this field "
            )
            .label("Account Holder Name")
        }
        return schema
      }),
      branchName: string(),
      bank: mixed(),
      paymentMethod: mixed(),
      ifscCode: string(),
      attachments: array(),
    })
  ),
  operationalSlots: object({
    deliverySlots: array().of(
      object({
        slots: array().of(number()),
        maximumOrders: number(),
        thresholdFrom: mixed(),
        estimatedDelivery: mixed(),
      })
    ),
    pickupSlots: array().of(mixed()),
    maintenanceSlots: array().of(mixed()),
    alternateSalesSlots: array().of(mixed()),
  }),
  deliveryCharges: object({
    isManufacturingPlant: boolean().nullable(),
    deliveryCosts: array()
      .of(mixed())
      .min(1, "Please enter atleast one delivery condition"),
    minCartValue: number()
      .positive()
      .transform(v => v || 0),
    estimatedDelta: mixed(),
    extraSapCodes: mixed(),
  }),
  stockPreferences: object({
    currentStockPercentage: currentStockPercentageField,
  }),
})
export default DCRegistrationFormModel
